"use client"

import { useState, useEffect } from "react"
import WalletDashboard from "../components/WalletDashboard"
import SendModal from "../components/SendModal"
import ReceiveModal from "../components/ReceiveModal"
import { ShieldModal } from "../components/shield"


function Dashboard() {
  useEffect(() => {
    document.title = "Piggy Bank - KAXAA Wallet"
  }, [])

  return (
    <>
      {/* {mode === 'private' && (
      <div className="private-mode">
        Private mode is active
      </div>
    )} */}
      <WalletDashboard />
    </>
  )
}

export default Dashboard
